import React from "react"
import { Container, Wrapper, ActorThumbnail, Image, Content, Name, Subtitle, Biography } from "./styles/actorHero"
import { Container as MainContainer } from "../../containers"

export default function ActorHero({ children, ...rest }) {
  return (
    <Container>
      <MainContainer>{children}</MainContainer>
    </Container>
  )
}

ActorHero.Wrapper = function ActorWrapper({ children, ...rest }) {
  return <Wrapper {...rest}>{children}</Wrapper>
}

ActorHero.Thumbnail = function Thumbnail({ src, ...rest }) {
  return (
    <ActorThumbnail {...rest}>
      <Image src={src} alt="Actor-Profile" />
    </ActorThumbnail>
  )
}

ActorHero.Content = function ActorContent({ children, ...rest }) {
  return <Content {...rest}>{children}</Content>
}

ActorHero.Name = function ActorName({ children, ...rest }) {
  return <Name {...rest}>{children}</Name>
}
ActorHero.Subtitle = function ActorSubtitle({ children, ...rest }) {
  return <Subtitle {...rest}>{children}</Subtitle>
}
ActorHero.Biography = function ActorBiography({ children, ...rest }) {
  return <Biography {...rest}>{children}</Biography>
}
